import Vue from "vue";
import axios from "axios";

const PRESIDENTIALELECTIONS_2 = "elec_pres_second_round";
const PRESIDENTIALELECTIONS_2_STATEGRAPH = "elec_pres_second_round_state_graph";
const state = () => ({
  pres2022_1_historicGraph: null,
  pres2022_2_historicGraph: null,
  pres2022_2_stateGraph: null,
  pres2022_2_bulletin: null,
  current_location: "Nacional",
  isLoading: [],
  colMap: null,
  colMap2026: null,
  pres2026_2_home:
    localStorage.getItem(PRESIDENTIALELECTIONS_2) &&
    localStorage.getItem(PRESIDENTIALELECTIONS_2) != "undefined"
      ? JSON.parse(localStorage.getItem(PRESIDENTIALELECTIONS_2))
      : null,
});

const getters = {
  pres2022_1_historicGraph: (state) => {
    return state.pres2022_1_historicGraph;
  },
  pres2022_2_historicGraph: (state) => {
    return state.pres2022_2_historicGraph;
  },
  pres2022_2_stateGraph: (state) => {
    return state.pres2022_2_stateGraph;
  },
  pres2022_2_bulletin: (state) => {
    return state.pres2022_2_bulletin;
  },
  pres2022_2_enabled: (state) => {
    return state.pres2022_2_bulletin && state.pres2022_2_bulletin.candidates;
  },
  colMap: (state) => {
    return state.colMap;
  },
  colMap2026: (state) => {
    return state.colMap2026;
  },
  pres2026_2_home: (state) => {
    return state.pres2026_2_home;
  },
};

const actions = {
  getPres2022_1_HistoricGraph({ commit, state }, location) {
    if (
      state.isLoading.indexOf("pres2022_1_historicGraph") == -1 &&
      !state.pres2022_1_historicGraph
    ) {
      commit("addLoading", {
        name: "pres2022_1_historicGraph",
      });
      const params = {};
      if (location) {
        params.state = location;
      }
      axios
        .get("https://elections.lalr.co/api/p1/2022/historic-graph", {
          params: params,
        })
        .then((q) => {
          if (q.data && q.data.datasetValues) {
            commit("setState", {
              name: "pres2022_1_historicGraph",
              data: q.data,
            });
          }
          commit("removeLoading", {
            name: "pres2022_1_historicGraph",
          });
        });
    }
  },
  getPres2022_2_HistoricGraph({ commit, state }, location) {
    if (
      state.isLoading.indexOf("pres2022_2_historicGraph") == -1 &&
      !state.pres2022_2_historicGraph
    ) {
      commit("addLoading", {
        name: "pres2022_2_historicGraph",
      });
      const params = {};
      if (location) {
        params.state = location;
      }
      axios
        .get("https://elections.lalr.co/api/p2/2022/historic-graph", {
          params: params,
        })
        .then((q) => {
          if (q.data && q.data.datasetValues) {
            commit("setState", {
              name: "pres2022_2_historicGraph",
              data: q.data,
            });
          }
          commit("removeLoading", {
            name: "pres2022_2_historicGraph",
          });
        });
    }
  },
  getPres2022_2_StateGraph({ commit, state }, location) {
    if (
      state.isLoading.indexOf("pres2022_2_stateGraph") == -1 &&
      !state.pres2022_2_stateGraph
    ) {
      commit("addLoading", {
        name: "pres2022_2_stateGraph",
      });
      const params = {};
      if (location) {
        params.location = location;
      }
      axios
        .get("https://elections.lalr.co/api/p2/2022/state-graph", {
          params: params,
        })
        .then((q) => {
          if (q.data && q.data.datasetValues) {
            commit("setState", {
              name: "pres2022_2_stateGraph",
              data: q.data,
            });
          }
          commit("removeLoading", {
            name: "pres2022_2_stateGraph",
          });
        });
    }
  },

  getPres2022_2_Bulletin({ commit, state }, location) {
    if (
      state.isLoading.indexOf("pres2022_2_bulletin") == -1 &&
      !state.pres2022_2_bulletin
    ) {
      commit("addLoading", {
        name: "pres2022_2_bulletin",
      });
      const params = {};
      if (location) {
        params.state = location;
      }
      axios
        .get("https://elections.lalr.co/api/p2/2022/bulletin", {
          params: params,
        })
        .then((q) => {
          if (q.data) {
            commit("setState", {
              name: "pres2022_2_bulletin",
              data: q.data,
            });
          }
          commit("removeLoading", {
            name: "pres2022_2_bulletin",
          });
        });
    }
  },
  setPres2022_2_Bulletin({ commit }, data) {
    commit("setState", {
      name: "pres2022_2_bulletin",
      data: data,
    });
  },
  setPres2022_2_StateGraph({ commit }, data) {
    commit("setState", {
      name: "pres2022_2_stateGraph",
      data: data,
    });
  },
  setPres2026_2_StateGraph({ commit }, data) {
    commit("setState", {
      name: "pres2026_2_home",
      data: data,
    });
  },
  addPres2022_2_HistoricGraph({ commit, state, dispatch }, data) {
    if (state.pres2022_2_historicGraph) {
      commit("addPres2022_2_HistoricGraph", {
        data: data,
      });
    } else {
      dispatch("getPres2022_2_HistoricGraph");
    }
  },
  initMap2026({ commit, state }) {
    if (state.isLoading.indexOf("col-map-2026") == -1 && !state.colMap2026) {
      commit("addLoading", {
        name: "col-map-2026",
      });
      axios.get("https://s.lalr.co/maps/colv2.json").then((q) => {
        commit("setState", {
          name: "colMap2026",
          data: q.data,
        });
        commit("removeLoading", {
          name: "col-map-2026",
        });
      });
    }
  },
  initMap({ commit, state }) {
    if (state.isLoading.indexOf("col-map") == -1 && !state.colMap) {
      commit("addLoading", {
        name: "col-map",
      });
      axios.get("https://s.lalr.co/maps/col.json").then((q) => {
        commit("setState", {
          name: "colMap",
          data: q.data,
        });
        commit("removeLoading", {
          name: "col-map",
        });
      });
    }
  },
  getPres2026_2_Home({ commit, state }, location) {
    if (state.isLoading.indexOf("pres2026_2_home") == -1) {
      commit("addLoading", {
        name: "pres2026_2_home",
      });

      const params = {};
      if (location) {
        params.state = location;
        commit("setState", {
          name: "current_location",
          data: location,
        });
      }

      axios
        .get("https://elections.lalr.co/api/p2/2026/election-report", {
          params: params,
        })
        .then((q) => {
          if (q.data) {
            localStorage.setItem(
              PRESIDENTIALELECTIONS_2,
              JSON.stringify(q.data),
            );
            commit("setState", {
              name: "pres2026_2_home",
              data: q.data,
            });
          }
          commit("removeLoading", {
            name: "pres2026_2_home",
          });
        });
    }
  },
  updatePres2026_2_Home({ commit, state }, data) {
    const is_older =
      data.lastBulletin.bulletin.bulletinNumber >
      state.pres2026_2_home.lastBulletin.bulletin.bulletinNumber;
    if (state.current_location == "Nacional" && is_older) {
      commit("updatePres2026_2_Home", {
        data: data,
      });
    }
  },
};

const mutations = {
  setState(state, { name, data }) {
    Vue.set(state, name, data);
  },
  cleanState(state, { name }) {
    Vue.delete(state, name);
  },
  addLoading(state, { name }) {
    state.isLoading.push(name);
  },
  removeLoading(state, { name }) {
    const idx = state.isLoading.indexOf(name);
    if (idx > -1) {
      state.isLoading.splice(idx, 1);
    }
  },
  addPres2022_2_HistoricGraph(state, { data }) {
    var oldData = state.pres2022_2_historicGraph;
    if (oldData && oldData.datasetValues && data && data.values) {
      oldData.datasetValues.push(data.values);
    }

    if (oldData && oldData.datasetPercentage && data && data.percentages) {
      oldData.datasetPercentage.push(data.percentages);
    }
    Vue.set(state, "pres2022_2_historicGraph", oldData);
  },
  updatePres2026_2_Home(state, { data }) {
    localStorage.setItem(PRESIDENTIALELECTIONS_2, JSON.stringify(data));
    Vue.set(state, "pres2026_2_home", data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
